let renderDrafts = false;

// The following is needed until the API responds with
// pre-cut-off links
if (typeof window === 'undefined') {
  // eslint-disable-next-line global-require
  const process = require('process');

  if (
    process
    && process.env
    && process.env.SWINGERCLUB_DRAFTS
    && (
      process.env.SWINGERCLUB_DRAFTS === true
      || process.env.SWINGERCLUB_DRAFTS.trim() === 'true'
    )
  ) {
    renderDrafts = true;
  }
}

module.exports = renderDrafts;



// WEBPACK FOOTER //
// ./src/_utilities/render-drafts.js